import 'select2/dist/css/select2.min.css';
import '../styles/index.scss';
import $ from 'jquery';

import EasyPieChart from 'easy-pie-chart';
import select2 from 'select2';
import scrollTo from 'jquery.scrollto';
import { TweenMax, timeLineMax } from 'gsap';

$(document).ready(function () {

    const questionsCount = $('.question').length;
    let currentQuestion = 1;

    let dataObject = {};
    
    function calculateNutrition(dataNutrition) {
        let result = 0;

        if (dataNutrition.gender == "female") {
            result = ((655 + (4.35 * dataNutrition.weight + 4.7 * dataNutrition.height - 4.7 * dataNutrition.age)) * dataNutrition.activity) + dataNutrition.goal;
        }

        if (dataNutrition.gender == "male") {
            result = ((66 + (6.23 * dataNutrition.weight + 12.7 * dataNutrition.height - 6.76 * dataNutrition.age)) * dataNutrition.activity) + dataNutrition.goal;
        }

        let proteinPer, fatPer, carbsPer;

        switch (dataNutrition.diet) {
            case 1:
                proteinPer = 35;
                fatPer = 30;
                carbsPer = 35;
                break;
            case 2:
                proteinPer = 30;
                fatPer = 25;
                carbsPer = 45;
                break;
            case 3:
                proteinPer = 30;
                fatPer = 55;
                carbsPer = 15;
                break;
        }

        result = result.toFixed(0);

        let protein = (result / 4 * proteinPer / 100).toFixed(0);
        let fat = (result / 9 * fatPer / 100).toFixed(0);
        let carbs = (result / 4 * carbsPer / 100).toFixed(0);

        $(".totalCal").text(result);
        $("#totalProtein span").text(protein);
        $("#totalCarbs span").text(carbs);
        $("#totalFat span").text(fat);

        $("#totalProtein").attr("data-percent", proteinPer);
        $("#totalCarbs").attr("data-percent", carbsPer);
        $("#totalFat").attr("data-percent", fatPer);
        // showResult();
        startChart();
        setTimeout(function () {
            showResult();
        }, 800);
        $("#meals").empty();
        for (let i = 1; i <= dataNutrition.meals; i++) {
            let mealItem = `
                <div class="meal">
                    <p class="meal-title">Meal ${i}</p>
                    <p>Protein: ${Math.round(protein / dataNutrition.meals)}g</p>
                    <p>Carbs: ${Math.round(carbs / dataNutrition.meals)}g</p>
                    <p>Fat: ${Math.round(fat / dataNutrition.meals)}g</p>
                </div>`;
            $("#meals").append(mealItem);
        }

    }

    $('.js-next').click(function (e) {

        switch (currentQuestion) {
            case 1:
                dataObject.gender = $("input[name='gender']:checked").val();
                break;
            case 2:
                dataObject.age = $("input[name='age']").val() * 1;
                break;
            case 3:
                dataObject.weight = $("input[name='weight']").val() * 1;
                break;
            case 4: {
                dataObject.height = $("input[name='feet']").val() * 12 + $("input[name='inches']").val() * 1;
                break;
            }
            case 5:
                dataObject.activity = $("select[name='activity']").val() ? $("select[name='activity']").val() * 1 : 1;
                break;
            case 6:
                dataObject.goal = $("select[name='goal']").val() ? $("select[name='goal']").val() * 1 : 1;
                displayGoalBundle(dataObject);
                break;
            case 7:
                dataObject.diet = $("select[name='diet']").val() ? $("select[name='diet']").val() * 1 : 1;

                break;
            case 8:
                dataObject.meals = $("input[name='meals']:checked").val() * 1;


                //    setTimeout(function(){
                //     $('.js-preloader').fadeOut(400);
                //    }, 3500);
                //    setTimeout(function(){ 

                //      $('.bundle.is-visible').fadeIn(400);
                //     // $(".questions .container").scrollTo($('.bundle.is-visible .h2'), 800, {offset:  0 })

                //    }, 4100);    
                // setTimeout(function () {
                //     showResult();
                // }, 4100);
                break;
            default:
                break;
        }

        if ($(this).hasClass("last")) {
            calculateNutrition(dataObject);
        }

        if ($(this).data('direction') === 'back') {
            currentQuestion--;

        } else {
            currentQuestion++;
            if ($(window).width() < 600) {
                $('.questions-line').attr('data-visible', currentQuestion !== 10);
            }
        }

        let progressWidth = currentQuestion / questionsCount * 100;
        $('.questions-progress-value').width(progressWidth + '%');

        $('.question').each(function (i, el) {
            $(el).attr('data-current', $(el).data('question') === currentQuestion);
        });
        $('.question-dot').each(function (i, el) {
            if (currentQuestion === $(el).data('question')) {
                $(el).attr('data-state', 'current');
            } else if (currentQuestion > $(el).data('question')) {
                $(el).attr('data-state', 'past');
            } else {
                $(el).attr('data-state', 'future');
            }
        });

    });

    $('.js-num-input').on('input', function () {
        $(this).val($(this).val().replace(/\D/, ''));
    });

    $('.js-input').on('input', function () {
        if ($(this).val()) {
            $(this).closest('.question').find('.js-next').removeAttr('disabled');
        }
    });

    $('.select2').select2({
        width: '100%',
        minimumResultsForSearch: -1,
    });
    var popupSelect = $('.popup-select').select2({
        width: '100%',
        minimumResultsForSearch: -1
    });
    $(popupSelect).each(function () {
        $(this).data('select2').$dropdown.addClass("popup-select__dropdown");
    });


    $('.js-choose-flavor').change(function () {
        const buyBundleBtn = $(this).closest('.popup').find('.js-buy-bundle');
        buyBundleBtn.attr('href', $(this).val());
    });


    function startChart() {
        let $chart = $('.chart-content'),
            lineWidth = $(window).width() > 1025 ? 20 : 10,
            size,
            clearSet;

        let chartsInit = (size, lineWidth) => {
            let element1 = document.querySelector('.circle-1');
            new EasyPieChart(element1, {
                size: size,
                scaleLength: 0,
                lineWidth: lineWidth,
                lineCap: 'square',
                barColor: '#3998e8'
            });
            let element2 = document.querySelector('.circle-2');
            new EasyPieChart(element2, {
                size: size,
                scaleLength: 0,
                lineWidth: lineWidth,
                lineCap: 'square',
                barColor: '#3998e8'
            });
            let element3 = document.querySelector('.circle-3');
            new EasyPieChart(element3, {
                size: size,
                scaleLength: 0,
                lineWidth: lineWidth,
                lineCap: 'square',
                barColor: '#3998e8'
            });
        };

        setTimeout(() => {
            size = parseFloat($chart.outerWidth());
            chartsInit(size, lineWidth);
        }, 300);

        $(window).on('resize', function () {

            if ($(window).width() < 1025) {
                lineWidth = 10;
            }

            size = parseFloat($chart.outerWidth());

            $chart.css({
                height: size
            });

            clearTimeout(clearSet);
            clearSet = setTimeout(function () {
                $chart.removeData('easyPieChart').find('canvas').remove();
                chartsInit(size, lineWidth);
            }, 100);
        });
    }

    $('.hamburger-menu').click(function () {
        $(this).toggleClass('active');
        $('.menu').toggleClass('active');
        $('body').toggleClass('overflow-hidden');
    });

    $('.js-submenu').click(function () {
        $(this).next().addClass('active');
    });

    $('.menu-back').click(function () {
        $(this).parent().removeClass('active');
    });


    $('.js-popup-open').click(function (e) {
        e.preventDefault();
        const popup = $(this).attr('data-popup');
        $('.popup[data-popup=' + popup + ']').attr('data-visible', true);
    });

    $('.popup').click(function (e) {
        if (e.target.className.indexOf('js-popup-close') !== -1) {
            $(this).attr('data-visible', false);
        }
    });

    function displayGoalBundle(dataNutrition) {
        document.querySelectorAll('.bundle').forEach(el => el.classList.remove('is-visible'));
        if (dataNutrition.goal === 0) {
            document.querySelector('.bundle--maintain').classList.add('is-visible');
        } else if (dataNutrition.goal === 300) {
            document.querySelector('.bundle--build').classList.add('is-visible');
        } else {
            document.querySelector('.bundle--burn').classList.add('is-visible');
        }
    };





    function showResult() {
        console.log('done');
        const activeItem = $('.result-overlay__item');
        $('.result-overlay').fadeIn(600);

        function animateTitle(i) {
            if (i > 0) {
                activeItem.eq(i - 1).addClass('is-visible');
            }
            if (i > 1) {
                activeItem.eq(i - 2).addClass('is-hidden');

            }
            if (i == 5) {
                activeItem.eq(i - 1).css({opacity: 0});

                setTimeout(() => { activeItem.eq(i).addClass('fade'); }, 3000);
                setTimeout(() => { animateTitle(i + 1); }, 3000);
            }else{
                setTimeout(() => { animateTitle(i + 1); }, 2000);
            }
            if (i == activeItem.length) {
                $('.bundle.is-visible').show();
                $('.result-overlay').fadeOut(600);

                const w = $(window).outerWidth();
                if (w < 768) {
                    $.scrollTo($('.bundle.is-visible .h2'), 800, { offset: 0 });
                } else { 
                    $(".questions .container").scrollTo($('.bundle.is-visible .h2'), 800, { offset: 0 });
 
                }

                $(".questions .container").scrollTo($('.bundle.is-visible .h2'), 800, { offset: 0 });
                return;
            }
            activeItem.eq(i).addClass('is-active');

            // setTimeout(() => { animateTitle(i + 1); }, 2000);
        };

        animateTitle(0);
    };



});


